import PowerstreamCooperation from '@elem/compPage/PowerstreamCooperation';
import { useState } from 'react';
import dynamic from 'next/dynamic';
import { useGlobal } from '@/utils/useGlobal';
import ProductNav from '@/components/ProductCommon/ProductNav';
import ProductSpecs from '@/components/ProductCommon/ProductSpecs';
import PageLayout from '@/components/PageLayout';
import SEOlinksA from '@/components/SEOlinksA';
import { useSupportData } from '@/utils/hooks';
import ProductSupport from '@/components/ProductCommon/ProductSupport';
import { getProductMsg, getProductFromGeneralKey } from '@/utils/productGetServerSideProps';
import { GENERAL_KEY, PRODUCT_KEY } from '@/constants/powerStream';
import { redirectTo404 } from '@/utils';

const WHITE_SITE = ['fr', 'it', 'es'];

export default function Page({ SEO }: any) {
    const { useRouter, useLang, gloproductlist } = useGlobal();
    const { t } = useLang('powerstreamcooperation');
    const router = useRouter();
    const { locale } = router;
    const [showTab, setShowTab] = useState('Overview');
    const theme = 'white';
    const GtmPageLoad = dynamic(() => import('@/components/GtmPageLoad'), { ssr: false });
    // 从全局的列表中--获取产品详情的基本信息
    const productMsg = getProductFromGeneralKey({ gloproductlist, generalKey: GENERAL_KEY });
    const [resProductCatagory, productDetail, supportData] = useSupportData(getProductMsg, locale, productMsg);

    // 切换tab
    const tabState = (val: any) => {
        document.querySelector('.product-tab.show-tab')?.classList.remove('show-tab');
        document.querySelector(`.product-tab-${val}`)?.classList.add('show-tab');
        setShowTab(val);
    };

    return (
        <PageLayout isNoFixed>
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <SEOlinksA locale={String(locale)} list={WHITE_SITE} pathname="powerstream-cooperation" />
            <GtmPageLoad />
            <ProductNav
                className="wbg"
                title={productMsg?.name}
                theme={theme}
                buyLink={productMsg?.buyLink || ''}
                callback={tabState}
                productKey={PRODUCT_KEY}
            />
            <div className="product-tab product-tab-Overview show-tab">{showTab === 'Overview' && <PowerstreamCooperation />}</div>
            <div className="product-tab product-tab-Specs">
                {showTab === 'Specs' && <ProductSpecs theme={theme} productDetail={productDetail} resProductCatagory={resProductCatagory} />}
            </div>
            <div className="product-tab product-tab-Support">
                {showTab === 'Support' && <ProductSupport theme={theme} supportData={supportData}></ProductSupport>}
            </div>
        </PageLayout>
    );
}

export async function getServerSideProps(context: any) {
    const prevPath = context.req.headers.referer;
    const { redirect } = context.query;
    const { locale = 'us' } = context;
    if (!WHITE_SITE.includes(locale)) {
        return redirectTo404();
    }
    return {
        props: {
            redirect: redirect || '',
            prevPath: prevPath || '',
        },
    };
}
